
import React from 'react';

import { ReactComponent as Policy } from '../assets/icons/Policy.svg';
import { ReactComponent as about_b } from '../assets/icons/about_b.svg';
import { ReactComponent as about_big } from '../assets/icons/about_big.svg';
import { ReactComponent as account } from '../assets/icons/account.svg';
import { ReactComponent as add } from '../assets/icons/add.svg';
import { ReactComponent as add_project } from '../assets/icons/add_project.svg';
import { ReactComponent as analytics } from '../assets/icons/analytics.svg';
import { ReactComponent as analytics_b } from '../assets/icons/analytics_b.svg';
import { ReactComponent as analytics_bb } from '../assets/icons/analytics_bb.svg';
import { ReactComponent as android } from '../assets/icons/android.svg';
import { ReactComponent as android_fill } from '../assets/icons/android_fill.svg';
import { ReactComponent as apple } from '../assets/icons/apple.svg';
import { ReactComponent as apple_fill } from '../assets/icons/apple_fill.svg';
import { ReactComponent as apps } from '../assets/icons/apps.svg';
import { ReactComponent as archive } from '../assets/icons/archive.svg';
import { ReactComponent as attach } from '../assets/icons/attach.svg';
import { ReactComponent as back } from '../assets/icons/back.svg';
import { ReactComponent as bag } from '../assets/icons/bag.svg';
import { ReactComponent as behance_line } from '../assets/icons/behance_line.svg';
import { ReactComponent as blocked } from '../assets/icons/blocked.svg';
import { ReactComponent as blog } from '../assets/icons/blog.svg';
import { ReactComponent as blog_line } from '../assets/icons/blog_line.svg';
import { ReactComponent as book } from '../assets/icons/book.svg';
import { ReactComponent as broken_link } from '../assets/icons/broken_link.svg';
import { ReactComponent as browser } from '../assets/icons/browser.svg';
import { ReactComponent as cal } from '../assets/icons/cal.svg';
import { ReactComponent as cal2 } from '../assets/icons/cal2.svg';
import { ReactComponent as camera } from '../assets/icons/camera.svg';
import { ReactComponent as caution } from '../assets/icons/caution.svg';
import { ReactComponent as chara00 } from '../assets/icons/chara00.svg';
import { ReactComponent as chara01 } from '../assets/icons/chara01.svg';
import { ReactComponent as chara_full00 } from '../assets/icons/chara_full00.svg';
import { ReactComponent as chat } from '../assets/icons/chat.svg';
import { ReactComponent as clear } from '../assets/icons/clear.svg';
import { ReactComponent as close } from '../assets/icons/close.svg';
import { ReactComponent as close_s } from '../assets/icons/close_s.svg';
import { ReactComponent as color } from '../assets/icons/color.svg';
import { ReactComponent as colorz_logo } from '../assets/icons/colorz_logo.svg';
import { ReactComponent as company } from '../assets/icons/company.svg';
import { ReactComponent as compareimage_logo } from '../assets/icons/compareimage_logo.svg';
import { ReactComponent as dark } from '../assets/icons/dark.svg';
import { ReactComponent as delete_account } from '../assets/icons/delete_account.svg';
import { ReactComponent as delete_icn } from '../assets/icons/delete_icn.svg';
import { ReactComponent as designer_ani } from '../assets/icons/designer_ani.svg';
import { ReactComponent as dots_off } from '../assets/icons/dots_off.svg';
import { ReactComponent as dots_on } from '../assets/icons/dots_on.svg';
import { ReactComponent as download } from '../assets/icons/download.svg';
import { ReactComponent as dribbble_line } from '../assets/icons/dribbble_line.svg';
import { ReactComponent as drop_down } from '../assets/icons/drop_down.svg';
import { ReactComponent as drop_up } from '../assets/icons/drop_up.svg';
import { ReactComponent as edit } from '../assets/icons/edit.svg';
import { ReactComponent as edit_ani } from '../assets/icons/edit_ani.svg';
import { ReactComponent as en } from '../assets/icons/en.svg';
import { ReactComponent as error } from '../assets/icons/error.svg';
import { ReactComponent as event } from '../assets/icons/event.svg';
import { ReactComponent as event_line } from '../assets/icons/event_line.svg';
import { ReactComponent as experience } from '../assets/icons/experience.svg';
import { ReactComponent as eye_off } from '../assets/icons/eye_off.svg';
import { ReactComponent as eye_on } from '../assets/icons/eye_on.svg';
import { ReactComponent as facebook_line } from '../assets/icons/facebook_line.svg';
import { ReactComponent as fav } from '../assets/icons/fav.svg';
import { ReactComponent as figma_line } from '../assets/icons/figma_line.svg';
import { ReactComponent as flag } from '../assets/icons/flag.svg';
import { ReactComponent as free } from '../assets/icons/free.svg';
import { ReactComponent as freemium } from '../assets/icons/freemium.svg';
import { ReactComponent as full } from '../assets/icons/full.svg';
import { ReactComponent as game_b } from '../assets/icons/game_b.svg';
import { ReactComponent as globe } from '../assets/icons/globe.svg';
import { ReactComponent as gmail } from '../assets/icons/gmail.svg';
import { ReactComponent as guide } from '../assets/icons/guide.svg';
import { ReactComponent as hand1 } from '../assets/icons/hand1.svg';
import { ReactComponent as hand2 } from '../assets/icons/hand2.svg';
import { ReactComponent as hand3 } from '../assets/icons/hand3.svg';
import { ReactComponent as hand4 } from '../assets/icons/hand4.svg';
import { ReactComponent as heart } from '../assets/icons/heart.svg';
import { ReactComponent as heart2 } from '../assets/icons/heart2.svg';
import { ReactComponent as home } from '../assets/icons/home.svg';
import { ReactComponent as horror } from '../assets/icons/horror.svg';
import { ReactComponent as hum } from '../assets/icons/hum.svg';
import { ReactComponent as hum2 } from '../assets/icons/hum2.svg';
import { ReactComponent as human } from '../assets/icons/human.svg';
import { ReactComponent as iap } from '../assets/icons/iap.svg';
import { ReactComponent as id } from '../assets/icons/id.svg';
import { ReactComponent as id_1 } from '../assets/icons/id_1.svg';
import { ReactComponent as idea } from '../assets/icons/idea.svg';
import { ReactComponent as image } from '../assets/icons/image.svg';
import { ReactComponent as images } from '../assets/icons/images.svg';
import { ReactComponent as instagram_line } from '../assets/icons/instagram_line.svg';
import { ReactComponent as invitation } from '../assets/icons/invitation.svg';
import { ReactComponent as item_name } from '../assets/icons/item_name.svg';
import { ReactComponent as items } from '../assets/icons/items.svg';
import { ReactComponent as job } from '../assets/icons/job.svg';
import { ReactComponent as jobs } from '../assets/icons/jobs.svg';
import { ReactComponent as jp } from '../assets/icons/jp.svg';
import { ReactComponent as juusando_logo } from '../assets/icons/juusando_logo.svg';
import { ReactComponent as juusando_text } from '../assets/icons/juusando_text.svg';
import { ReactComponent as language } from '../assets/icons/language.svg';
import { ReactComponent as left_arrow } from '../assets/icons/left_arrow.svg';
import { ReactComponent as light } from '../assets/icons/light.svg';
import { ReactComponent as like } from '../assets/icons/like.svg';
import { ReactComponent as line } from '../assets/icons/line.svg';
import { ReactComponent as link_ext } from '../assets/icons/link_ext.svg';
import { ReactComponent as linkedin_line } from '../assets/icons/linkedin_line.svg';
import { ReactComponent as linux } from '../assets/icons/linux.svg';
import { ReactComponent as load } from '../assets/icons/load.svg';
import { ReactComponent as loading } from '../assets/icons/loading.svg';
import { ReactComponent as loading_ } from '../assets/icons/loading_.svg';
import { ReactComponent as loading_ani } from '../assets/icons/loading_ani.svg';
import { ReactComponent as lock } from '../assets/icons/lock.svg';
import { ReactComponent as login } from '../assets/icons/login.svg';
import { ReactComponent as logo01 } from '../assets/icons/logo01.svg';
import { ReactComponent as logo02 } from '../assets/icons/logo02.svg';
import { ReactComponent as logo03 } from '../assets/icons/logo03.svg';
import { ReactComponent as logo04 } from '../assets/icons/logo04.svg';
import { ReactComponent as logo05 } from '../assets/icons/logo05.svg';
import { ReactComponent as logo06 } from '../assets/icons/logo06.svg';
import { ReactComponent as logotype_en } from '../assets/icons/logotype_en.svg';
import { ReactComponent as logotype_jp } from '../assets/icons/logotype_jp.svg';
import { ReactComponent as logout } from '../assets/icons/logout.svg';
import { ReactComponent as mail } from '../assets/icons/mail.svg';
import { ReactComponent as mail2 } from '../assets/icons/mail2.svg';
import { ReactComponent as mail_ani } from '../assets/icons/mail_ani.svg';
import { ReactComponent as mail_b } from '../assets/icons/mail_b.svg';
import { ReactComponent as map } from '../assets/icons/map.svg';
import { ReactComponent as message_back } from '../assets/icons/message_back.svg';
import { ReactComponent as mic } from '../assets/icons/mic.svg';
import { ReactComponent as money } from '../assets/icons/money.svg';
import { ReactComponent as mute_off } from '../assets/icons/mute_off.svg';
import { ReactComponent as mute_on } from '../assets/icons/mute_on.svg';
import { ReactComponent as name_card } from '../assets/icons/name_card.svg';
import { ReactComponent as namecard } from '../assets/icons/namecard.svg';
import { ReactComponent as namecard_2 } from '../assets/icons/namecard_2.svg';
import { ReactComponent as new_mail } from '../assets/icons/new_mail.svg';
import { ReactComponent as new_password } from '../assets/icons/new_password.svg';
import { ReactComponent as news } from '../assets/icons/news.svg';
import { ReactComponent as newsletter } from '../assets/icons/newsletter.svg';
import { ReactComponent as newz } from '../assets/icons/newz.svg';
import { ReactComponent as no_item } from '../assets/icons/no_item.svg';
import { ReactComponent as norif_off } from '../assets/icons/norif_off.svg';
import { ReactComponent as norif_on } from '../assets/icons/norif_on.svg';
import { ReactComponent as ok } from '../assets/icons/ok.svg';
import { ReactComponent as order_az } from '../assets/icons/order_az.svg';
import { ReactComponent as order_za } from '../assets/icons/order_za.svg';
import { ReactComponent as paid } from '../assets/icons/paid.svg';
import { ReactComponent as password } from '../assets/icons/password.svg';
import { ReactComponent as pause } from '../assets/icons/pause.svg';
import { ReactComponent as pause2 } from '../assets/icons/pause2.svg';
import { ReactComponent as phone } from '../assets/icons/phone.svg';
import { ReactComponent as pin } from '../assets/icons/pin.svg';
import { ReactComponent as pin_in } from '../assets/icons/pin_in.svg';
import { ReactComponent as pin_in_ani } from '../assets/icons/pin_in_ani.svg';
import { ReactComponent as pinjob } from '../assets/icons/pinjob.svg';
import { ReactComponent as pinjob_ani } from '../assets/icons/pinjob_ani.svg';
import { ReactComponent as popup } from '../assets/icons/popup.svg';
import { ReactComponent as post } from '../assets/icons/post.svg';
import { ReactComponent as press } from '../assets/icons/press.svg';
import { ReactComponent as press_kit } from '../assets/icons/press_kit.svg';
import { ReactComponent as privacy } from '../assets/icons/privacy.svg';
import { ReactComponent as project } from '../assets/icons/project.svg';
import { ReactComponent as pull_down } from '../assets/icons/pull_down.svg';
import { ReactComponent as pull_up } from '../assets/icons/pull_up.svg';
import { ReactComponent as randomcolorz } from '../assets/icons/randomcolorz.svg';
import { ReactComponent as randomcolorz_logo } from '../assets/icons/randomcolorz_logo.svg';
import { ReactComponent as register } from '../assets/icons/register.svg';
import { ReactComponent as report } from '../assets/icons/report.svg';
import { ReactComponent as reqest } from '../assets/icons/reqest.svg';
import { ReactComponent as reset } from '../assets/icons/reset.svg';
import { ReactComponent as reset2 } from '../assets/icons/reset2.svg';
import { ReactComponent as resos } from '../assets/icons/resos.svg';
import { ReactComponent as restart } from '../assets/icons/restart.svg';
import { ReactComponent as right_arrow } from '../assets/icons/right_arrow.svg';
import { ReactComponent as right_arrow_ani } from '../assets/icons/right_arrow_ani.svg';
import { ReactComponent as robot } from '../assets/icons/robot.svg';
import { ReactComponent as save } from '../assets/icons/save.svg';
import { ReactComponent as screen } from '../assets/icons/screen.svg';
import { ReactComponent as search } from '../assets/icons/search.svg';
import { ReactComponent as search_ani } from '../assets/icons/search_ani.svg';
import { ReactComponent as send } from '../assets/icons/send.svg';
import { ReactComponent as send_ani } from '../assets/icons/send_ani.svg';
import { ReactComponent as separator } from '../assets/icons/separator.svg';
import { ReactComponent as service_b } from '../assets/icons/service_b.svg';
import { ReactComponent as services } from '../assets/icons/services.svg';
import { ReactComponent as services_bb } from '../assets/icons/services_bb.svg';
import { ReactComponent as setting } from '../assets/icons/setting.svg';
import { ReactComponent as setting_b } from '../assets/icons/setting_b.svg';
import { ReactComponent as shake_hands } from '../assets/icons/shake_hands.svg';
import { ReactComponent as side_in } from '../assets/icons/side_in.svg';
import { ReactComponent as side_out } from '../assets/icons/side_out.svg';
import { ReactComponent as signup } from '../assets/icons/signup.svg';
import { ReactComponent as small } from '../assets/icons/small.svg';
import { ReactComponent as small_arrow } from '../assets/icons/small_arrow.svg';
import { ReactComponent as start } from '../assets/icons/start.svg';
import { ReactComponent as stop } from '../assets/icons/stop.svg';
import { ReactComponent as subject } from '../assets/icons/subject.svg';
import { ReactComponent as tag } from '../assets/icons/tag.svg';
import { ReactComponent as talx } from '../assets/icons/talx.svg';
import { ReactComponent as terms } from '../assets/icons/terms.svg';
import { ReactComponent as threads_line } from '../assets/icons/threads_line.svg';
import { ReactComponent as tiktok_line } from '../assets/icons/tiktok_line.svg';
import { ReactComponent as timer } from '../assets/icons/timer.svg';
import { ReactComponent as timer_logo } from '../assets/icons/timer_logo.svg';
import { ReactComponent as tool } from '../assets/icons/tool.svg';
import { ReactComponent as trash } from '../assets/icons/trash.svg';
import { ReactComponent as twitter_line } from '../assets/icons/twitter_line.svg';
import { ReactComponent as unarchive } from '../assets/icons/unarchive.svg';
import { ReactComponent as unpin } from '../assets/icons/unpin.svg';
import { ReactComponent as upload } from '../assets/icons/upload.svg';
import { ReactComponent as user } from '../assets/icons/user.svg';
import { ReactComponent as user_2 } from '../assets/icons/user_2.svg';
import { ReactComponent as user_bb } from '../assets/icons/user_bb.svg';
import { ReactComponent as user_circle } from '../assets/icons/user_circle.svg';
import { ReactComponent as username } from '../assets/icons/username.svg';
import { ReactComponent as users } from '../assets/icons/users.svg';
import { ReactComponent as uud1 } from '../assets/icons/uud1.svg';
import { ReactComponent as uud_icon } from '../assets/icons/uud_icon.svg';
import { ReactComponent as uud_icon2 } from '../assets/icons/uud_icon2.svg';
import { ReactComponent as uud_line } from '../assets/icons/uud_line.svg';
import { ReactComponent as uud_sns } from '../assets/icons/uud_sns.svg';
import { ReactComponent as uxer_2_on } from '../assets/icons/uxer_2_on.svg';
import { ReactComponent as uxer_simple } from '../assets/icons/uxer_simple.svg';
import { ReactComponent as uxers } from '../assets/icons/uxers.svg';
import { ReactComponent as view } from '../assets/icons/view.svg';
import { ReactComponent as view_link } from '../assets/icons/view_link.svg';
import { ReactComponent as web_line } from '../assets/icons/web_line.svg';
import { ReactComponent as windows } from '../assets/icons/windows.svg';
import { ReactComponent as windows_fill } from '../assets/icons/windows_fill.svg';
import { ReactComponent as youtube_line } from '../assets/icons/youtube_line.svg';

const iconComponents = {
  'Policy': Policy,
  'about_b': about_b,
  'about_big': about_big,
  'account': account,
  'add': add,
  'add_project': add_project,
  'analytics': analytics,
  'analytics_b': analytics_b,
  'analytics_bb': analytics_bb,
  'android': android,
  'android_fill': android_fill,
  'apple': apple,
  'apple_fill': apple_fill,
  'apps': apps,
  'archive': archive,
  'attach': attach,
  'back': back,
  'bag': bag,
  'behance_line': behance_line,
  'blocked': blocked,
  'blog': blog,
  'blog_line': blog_line,
  'book': book,
  'broken_link': broken_link,
  'browser': browser,
  'cal': cal,
  'cal2': cal2,
  'camera': camera,
  'caution': caution,
  'chara00': chara00,
  'chara01': chara01,
  'chara_full00': chara_full00,
  'chat': chat,
  'clear': clear,
  'close': close,
  'close_s': close_s,
  'color': color,
  'colorz_logo': colorz_logo,
  'company': company,
  'compareimage_logo': compareimage_logo,
  'dark': dark,
  'delete_account': delete_account,
  'delete_icn': delete_icn,
  'designer_ani': designer_ani,
  'dots_off': dots_off,
  'dots_on': dots_on,
  'download': download,
  'dribbble_line': dribbble_line,
  'drop_down': drop_down,
  'drop_up': drop_up,
  'edit': edit,
  'edit_ani': edit_ani,
  'en': en,
  'error': error,
  'event': event,
  'event_line': event_line,
  'experience': experience,
  'eye_off': eye_off,
  'eye_on': eye_on,
  'facebook_line': facebook_line,
  'fav': fav,
  'figma_line': figma_line,
  'flag': flag,
  'free': free,
  'freemium': freemium,
  'full': full,
  'game_b': game_b,
  'globe': globe,
  'gmail': gmail,
  'guide': guide,
  'hand1': hand1,
  'hand2': hand2,
  'hand3': hand3,
  'hand4': hand4,
  'heart': heart,
  'heart2': heart2,
  'home': home,
  'horror': horror,
  'hum': hum,
  'hum2': hum2,
  'human': human,
  'iap': iap,
  'id': id,
  'id_1': id_1,
  'idea': idea,
  'image': image,
  'images': images,
  'instagram_line': instagram_line,
  'invitation': invitation,
  'item_name': item_name,
  'items': items,
  'job': job,
  'jobs': jobs,
  'jp': jp,
  'juusando_logo': juusando_logo,
  'juusando_text': juusando_text,
  'language': language,
  'left_arrow': left_arrow,
  'light': light,
  'like': like,
  'line': line,
  'link_ext': link_ext,
  'linkedin_line': linkedin_line,
  'linux': linux,
  'load': load,
  'loading': loading,
  'loading_': loading_,
  'loading_ani': loading_ani,
  'lock': lock,
  'login': login,
  'logo01': logo01,
  'logo02': logo02,
  'logo03': logo03,
  'logo04': logo04,
  'logo05': logo05,
  'logo06': logo06,
  'logotype_en': logotype_en,
  'logotype_jp': logotype_jp,
  'logout': logout,
  'mail': mail,
  'mail2': mail2,
  'mail_ani': mail_ani,
  'mail_b': mail_b,
  'map': map,
  'message_back': message_back,
  'mic': mic,
  'money': money,
  'mute_off': mute_off,
  'mute_on': mute_on,
  'name_card': name_card,
  'namecard': namecard,
  'namecard_2': namecard_2,
  'new_mail': new_mail,
  'new_password': new_password,
  'news': news,
  'newsletter': newsletter,
  'newz': newz,
  'no_item': no_item,
  'norif_off': norif_off,
  'norif_on': norif_on,
  'ok': ok,
  'order_az': order_az,
  'order_za': order_za,
  'paid': paid,
  'password': password,
  'pause': pause,
  'pause2': pause2,
  'phone': phone,
  'pin': pin,
  'pin_in': pin_in,
  'pin_in_ani': pin_in_ani,
  'pinjob': pinjob,
  'pinjob_ani': pinjob_ani,
  'popup': popup,
  'post': post,
  'press': press,
  'press_kit': press_kit,
  'privacy': privacy,
  'project': project,
  'pull_down': pull_down,
  'pull_up': pull_up,
  'randomcolorz': randomcolorz,
  'randomcolorz_logo': randomcolorz_logo,
  'register': register,
  'report': report,
  'reqest': reqest,
  'reset': reset,
  'reset2': reset2,
  'resos': resos,
  'restart': restart,
  'right_arrow': right_arrow,
  'right_arrow_ani': right_arrow_ani,
  'robot': robot,
  'save': save,
  'screen': screen,
  'search': search,
  'search_ani': search_ani,
  'send': send,
  'send_ani': send_ani,
  'separator': separator,
  'service_b': service_b,
  'services': services,
  'services_bb': services_bb,
  'setting': setting,
  'setting_b': setting_b,
  'shake_hands': shake_hands,
  'side_in': side_in,
  'side_out': side_out,
  'signup': signup,
  'small': small,
  'small_arrow': small_arrow,
  'start': start,
  'stop': stop,
  'subject': subject,
  'tag': tag,
  'talx': talx,
  'terms': terms,
  'threads_line': threads_line,
  'tiktok_line': tiktok_line,
  'timer': timer,
  'timer_logo': timer_logo,
  'tool': tool,
  'trash': trash,
  'twitter_line': twitter_line,
  'unarchive': unarchive,
  'unpin': unpin,
  'upload': upload,
  'user': user,
  'user_2': user_2,
  'user_bb': user_bb,
  'user_circle': user_circle,
  'username': username,
  'users': users,
  'uud1': uud1,
  'uud_icon': uud_icon,
  'uud_icon2': uud_icon2,
  'uud_line': uud_line,
  'uud_sns': uud_sns,
  'uxer_2_on': uxer_2_on,
  'uxer_simple': uxer_simple,
  'uxers': uxers,
  'view': view,
  'view_link': view_link,
  'web_line': web_line,
  'windows': windows,
  'windows_fill': windows_fill,
  'youtube_line': youtube_line,
};

const SvgIcn = ({ name, ...props }) => {
  const SelectedIcon = iconComponents[name];
  if (!SelectedIcon) {
    console.warn(`Icon "${name}" not found`);
    return null; // Or a default icon
  }

  return <SelectedIcon {...props} />;
};

export default SvgIcn;
